// extracted by mini-css-extract-plugin
module.exports = {"page":"LoadingPage_page__2EWUZ","spinner":"LoadingPage_spinner__1nE8H","spinnerSector":"LoadingPage_spinnerSector__1wh8j","rotate":"LoadingPage_rotate__1XrEt"};